import React, { useEffect, useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Navbar from "../../navbar/navbar";
import Sidebar from "../../navbar/sidebar";
import api from "../../services/api";

//import AuthService from "../../services/auth.service";

const API_URL = "https://sivempc.veracruz.gob.mx/api/";
//const API_URL = "http://10.2.17.55:8000/api/";

export default function Actas() {
  document.title = "Editar Actas Circunstanciadas";

  const navigate = useNavigate();
  const [post, setPost] = useState([]);
  const [tempost, setTempost] = useState([]);
  const [changed, setChanged] = useState(false);
  const { id } = useParams();

  const getId = async (event) => {
    try {
      api.get(API_URL + `acta/${id}`).then((response) => {
        //console.log(response)
        setPost(response.data);
        setTempost(response.data);
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line
    getId();
    // eslint-disable-next-line
  }, []);

  const updatePost = async (event) => {
    try {
      api.put(API_URL + `editarActa/${id}`, tempost).then((response) => {
        //console.log(response.data)
        setTempost(response.data);
        navigate("/curso");
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="flex">
      <Sidebar />
      <div className="content-center w-100">
        <Navbar />
        <>
          {post ? (
            <div className="actaview">
              <br></br>
              <br></br>
              <br></br>
              <div>
                <div className="form-group">
                  <h4 className="text-center">
                    <strong>USO DE LA PALABRA</strong>
                  </h4>
                </div>
                <br></br>
                <div className="row g-3 justify-content-between">
                  <div className="col-auto texto">
                    Una vez concluida la presente visita de verificación, se
                    hace constar que el/la (los/las) dictaminadores(as)
                    actuante(s) comunicó(aron) a la persona verificada que de
                    conformidad con lo dispuesto en los artículos 169 del Código
                    de Procedimientos Administrativos para el Estado de Veracruz
                    de Ignacio de la Llave, tiene derecho en este acto a
                    formular observaciones y ofrecer pruebas en relación con los
                    hechos asentados en esta acta o que puede hacer uso de este
                    derecho por escrito, presentándolas en la Oficialía de
                    Partes de la Secretaría de Protección Civil del Estado,
                    citada en Torre Orgullo Veracruzano, Av Lázaro Cárdenas No.
                    1104-B pisos 5, 6 y 7, Col. Revolución Xalapa de Enríquez,
                    Veracruz, en el término de los cinco días hábiles siguientes
                    a la fecha de cierre de la presente diligencia. En
                    consecuencia, en uso de la palabra la persona C.
                  </div>
                  <div className="col-13">
                    <input
                      type="text"
                      value={tempost.persona_atiendediligencia || ""}
                      onChange={(e) => {
                        setChanged(true);
                        setTempost({
                          ...tempost,
                          persona_atiendediligencia: e.target.value,
                        });
                      }}
                      name="persona_atiendediligencia"
                      className="form-control"
                    ></input>
                  </div>
                  <div className="col-auto">Manifestó:</div>
                  <div className="mb-3">
                    <textarea
                      type="text"
                      value={tempost.manifesto || ""}
                      onChange={(e) => {
                        setChanged(true);
                        setTempost({ ...tempost, manifesto: e.target.value });
                      }}
                      name="manifesto"
                      className="form-control"
                      rows="5"
                    ></textarea>
                  </div>
                </div>
              </div>

              <br></br>
              <div>
                <div
                  className="form-group"
                  style={{ color: "red", marginBottom: "10px" }}
                >
                  <h4 className="text-center">
                    <strong>{changed ? <p>Editado</p> : null}</strong>
                  </h4>
                </div>
              </div>

              <br></br>
              <div className="list row justify-content-center">
                <button
                  className="m-2 btn btn-success btn-lg col-6"
                  //disabled={this.state.camposFaltantes}
                  onClick={updatePost}
                >
                  <AiOutlineCheck /> Actualizar
                </button>
              </div>
              <br></br>
            </div>
          ) : null}
        </>
      </div>
    </div>
  );
}
